<template>
    <!-- 底部区域 -->
    <div class="footer">
        <div class="conetnt_row">
            <div class="com_message">
                <div class="footer-logo">
                    <h5>微信客服:</h5>
                    <img src="../assets/erweima.jpg" alt="">
                </div>
                <div class="footer-call">
                    <p>联系我们:</p>
                    <h6>15657177655</h6>
                </div>
                <div class="footer-address">
                    <p>公司地址:</p>
                    <h6>浙江省杭州市萧山区北干街道恒隆广场4幢1217室</h6>
                </div>
            </div>

            <div class="footer-nav">
                <dl>
                    <dt>关于我们</dt>
                    <dd>
                        <router-link to="/about">
                            <span>企业介绍</span>
                        </router-link>
                    </dd>
                    <dd>
                        <router-link to="/about">
                            <span>企业介绍</span>
                        </router-link>
                    </dd>
                </dl>
                <dl>
                    <dt>解决方案</dt>
                    <dd>
                        <router-link to="/solution">
                            <span>数字农贸</span>
                        </router-link>
                    </dd>
                    <dd>
                        <router-link to="/solution">
                            <span>数字农批</span>
                        </router-link>
                    </dd>
                </dl>
                <dl>
                    <dt>产品服务</dt>
                    <dd>
                        <router-link to="/service">
                            <span>智慧秤</span>
                        </router-link>
                    </dd>
                    <dd>
                        <router-link to="/service">
                            <span>软件平台</span>
                        </router-link>
                    </dd>
                </dl>
                <dl>
                    <dt>成功案例</dt>
                    <dd>
                        <router-link to="/success">
                            <span>数字农贸</span>
                        </router-link>
                    </dd>
                    <dd>
                        <router-link to="/success">
                            <span>数字农批</span>
                        </router-link>
                    </dd>
                </dl>
                <dl>
                    <dt>新闻资讯</dt>
                    <dd>
                        <router-link to="/news">
                            <span>菜商云资讯</span>
                        </router-link>
                    </dd>
                    <dd>
                        <router-link to="/news">
                            <span>行业资讯</span>
                        </router-link>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="light"></div>
        <div class="beian">杭州菜商云数字科技有限公司 <a href="https://beian.miit.gov.cn/">浙ICP备2021037195号-1</a></div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    created() { },
    mounted() { },
    methods: {},
}
</script>

<style lang="less" scoped>
.footer {
    position: relative;
    width: 100%;
    height: 5.9063rem;
    background: #2E3033;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-top: .3125rem;
}

.footer .conetnt_row {
    // position: relative;
    // width: 12.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.com_message {
    display: flex;
    flex-direction: column;
    width: 40%;
    height: 60%;
}

.footer-logo {
    // position: absolute;
    // left: 0;
    // top: .9167rem;
    width: 1.5938rem;
    height: 1.4688rem;
    // margin-left: .108rem;
    margin-bottom: 40px;
}

.footer-logo img {
    width: 100%;
}

.footer-logo h5 {
    height: .2083rem;
    font-size: .1458rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: .2083rem;
    margin-bottom: .125rem;
}

.footer-call {
    // position: absolute;
    // left: .1042rem;
    // top: 3.208rem;
    width: 1.3333rem;
    height: .6667rem;
}

.footer-call p {
    height: .2083rem;
    font-size: .1458rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: .2083rem;
}

.footer-call h6 {
    height: .4167rem;
    font-size: .2917rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: .4167rem;
    margin-top: .0417rem;
}

.footer-address p {
    height: .2083rem;
    font-size: .1458rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: .2083rem;
}

.footer-address h6 {
    height: .2292rem;
    font-size: .1667rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: .2292rem;
    margin-top: .0625rem;

}

.footer-wx {
    position: absolute;
    left: .1042rem;
    top: 3.9583rem;
    width: .625rem;
    height: .375rem;
    background: #FFFFFF;
    border-radius: .0104rem;
    box-sizing: border-box;
    padding: 0.01rem 0 0 0.18rem;
}

.footer-wx p {
    width: .7208rem;
    height: .1771rem;
    font-size: .125rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #949498;
    line-height: .1771rem;
    margin-top: .1563rem;
    margin-left: -0.1563rem;
}

.footer-wx .erweima {
    display: none;
    position: absolute;
    top: 0;
    right: -100px;
    width: 90px;
    height: 90px;
    z-index: 6;
}

.footer-wx .erweima img {
    width: 100%;
}

.light {
    position: absolute;
    top: 5.1563rem;
    left: 0;
    width: 100%;
    height: .0104rem;
    color: #e3e3e6;
    border: .0104rem solid #E3E3E6;
}


.footer-nav dl {
    float: left;
    margin-left: .8333rem;
}

.footer-nav dt {
    height: .2604rem;
    font-size: .1875rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: .2604rem;
    margin-bottom: .4375rem;

}

.footer-nav dd {
    height: .2083rem;
    font-size: .1458rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #949498;
    line-height: .2083rem;
    margin-bottom: .2083rem;
}

.footer-nav dd a:hover {
    color: #08C667;
}

.beian {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 5.4rem;
    color: #fff;
    font-size: .22rem;
}
</style>